import { createAsyncThunk } from "@reduxjs/toolkit";
import { getActiveCourts, getDailySchedule } from "../rent/bitrixArenas";
import { mapBitrixDataToHalls, mapBitrixScheduleToTimes } from "../rent/bitrixArenasMapper";
import store from "../store";
import { IHall, ITime } from "./types";

export const fetchGetHalls = createAsyncThunk<IHall[]>(
  "halls/fetchGetHalls",
  async () => {
    try {
      const state = store.getState();
      const partnerId = (state as any).user?.partnerId;
      
      const today = new Date();
      const todayDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
      const isoDate = `${todayDate}T00:00:00`;
      
      const [activeCourtsResponse, dailyScheduleResponse] = await Promise.all([
        getActiveCourts(),
        getDailySchedule(partnerId, isoDate),
      ]);
      
      if (activeCourtsResponse.result && dailyScheduleResponse.result) {
        const halls = mapBitrixDataToHalls(activeCourtsResponse, dailyScheduleResponse);
        return halls;
      }
      
      return [];
    } catch (error) {
      throw error;
    }
  }
);

export const fetchGetHall = createAsyncThunk<ITime[], { hallId: number; date: string }>(
  "halls/fetchGetHall",
  async (data) => {
    try {
      const { hallId, date } = data;
      
      const state = store.getState();
      const partnerId = (state as any).user?.partnerId;
      
      const isoDate = `${date}T00:00:00`;
      
      const { getDailySchedule, getActiveCourts } = await import("../rent/bitrixArenas");
      const [dailyScheduleResponse, activeCourtsResponse] = await Promise.all([
        getDailySchedule(partnerId, isoDate),
        getActiveCourts(),
      ]);
      
      if (dailyScheduleResponse.result && activeCourtsResponse.result) {
        const courtIndex = hallId - 1;
        if (courtIndex >= 0 && courtIndex < activeCourtsResponse.activeCourts.length) {
          const court = activeCourtsResponse.activeCourts[courtIndex];
          if (court) {
            const times = mapBitrixScheduleToTimes(dailyScheduleResponse, court.courtId);
            return times;
          }
        }
      }
      
      return [];
    } catch (error) {
      throw error;
    }
  }
);
